/** @format */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import NoDataComponent from 'src/components/NoData'
import BaseChart from 'src/components/BaseChart'
import { formatDate } from 'src/utils'
import { monthDayHourMinute } from 'src/config/date'

interface IChartContentProps {
  className?: string
  chartData: any[]
}

interface IChartObjectProps {
  xData: string[]
  series: any[]
}

const ChartContent: React.FC<IChartContentProps> = ({ className, chartData }) => {
  const [chartObject, setChartObject] = useState<IChartObjectProps>({
    xData: [],
    series: []
  })

  useEffect(() => {
    const xData = []
    const series = []
    chartData.forEach(({ time, count }) => {
      xData.push(formatDate(time, monthDayHourMinute))
      series.push(count)
    })
    setChartObject({
      xData,
      series
    })
  }, [chartData])
  return chartData.length ? (
    <div className={className}>
      <BaseChart
        options={{
          color: ['#0091EA'],
          legend: {
            left: '150px',
            type: 'scroll'
          },
          xAxis: {
            type: 'category',
            // boundaryGap: false,
            data: chartObject?.xData
          },
          yAxis: {
            type: 'value',
            minInterval: 1
          },
          series: {
            data: chartObject.series,
            type: 'bar',
            barMaxWidth: 30,
            label: {
              show: true,
              position: 'top'
            }
          },
          grid: {
            left: '50px',
            right: '20px',
            top: '10%',
            bottom: '40px'
          }
        }}
      ></BaseChart>
    </div>
  ) : (
    <div className={className}>
      <NoDataComponent style={{ padding: 150 }} />
    </div>
  )
}

export default styled(ChartContent)`
  width: 100%;
  height: 350px;
  background: #fff;
  .tooltip-list {
    height: auto;
    max-height: 240px;
    overflow-y: auto;
    .tooltip-title {
      font-weight: bold;
    }
    p {
      color: #666;
      margin: 0;
      font-size: 14px;
      line-height: 20px;
    }
  }
`
